import { RedoShopifyCountryCode } from "@redotech/redo-model/fulfillments/fulfillment-country-code";
import { CompensationMethod } from "@redotech/redo-model/return";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const getReturnBearIntegration = {
  name: "getReturnBearIntegration" as const,
  input: z.object({}),
  output: z.object({
    returnBearIntegration: z.optional(
      z.object({
        enabled: z.boolean(),
        storeId: z.number(),
        dropoffLocationRadiusMiles: z.number(),
        eligibleShopperCountries: z.array(createEnum(RedoShopifyCountryCode)),
        eligibleAutoProcessCompensationMethods: z.array(
          createEnum(CompensationMethod),
        ),
      }),
    ),
    sendgrid: z.optional(
      z.object({
        enabled: z.boolean(),
        fromEmail: z.optional(z.string()),
        fromName: z.optional(z.string()),
      }),
    ),
  }),
};

export type GetReturnBearIntegrationOutput = z.infer<
  typeof getReturnBearIntegration.output
>;

export const setReturnBearIntegration = {
  name: "setReturnBearIntegration" as const,
  input: z.object({
    enabled: z.boolean(),
    storeId: z.number().min(1, "Store ID must be greater than 0"),
    dropoffLocationRadiusMiles: z
      .number()
      .min(1, "Radius must be at least 1 mile"),
    eligibleShopperCountries: z.array(createEnum(RedoShopifyCountryCode)),
    eligibleAutoProcessCompensationMethods: z.array(
      createEnum(CompensationMethod),
    ),
    sendgrid: z.optional(
      z.object({
        enabled: z.boolean().optional(),
        fromEmail: z.optional(z.string()),
        fromName: z.optional(z.string()),
      }),
    ),
  }),
  output: z.object({}),
};

export const updateReturnBearIntegration = {
  name: "updateReturnBearIntegration" as const,
  input: z.object({
    enabled: z.boolean().optional(),
    storeId: z.number().min(1, "Store ID must be greater than 0").optional(),
    dropoffLocationRadiusMiles: z
      .number()
      .min(1, "Radius must be at least 1 mile")
      .optional(),
    eligibleShopperCountries: z
      .array(createEnum(RedoShopifyCountryCode))
      .optional(),
    eligibleAutoProcessCompensationMethods: z
      .array(createEnum(CompensationMethod))
      .optional(),
    sendgrid: z.optional(
      z.object({
        enabled: z.boolean().optional(),
        fromEmail: z.optional(z.string()),
        fromName: z.optional(z.string()),
      }),
    ),
  }),
  output: z.object({}),
};

export const disconnectReturnBearIntegration = {
  name: "disconnectReturnBearIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
